<div class="dialog-container">
  <div class="dialog-header">
    <div class="header-content">
      <h2>{{ automation.name }}</h2>
      <div class="header-actions">
        <mat-slide-toggle
          [checked]="automation.enabled"
          (change)="toggleEnabled()"
          color="primary"
        ></mat-slide-toggle>
        <button
          *ngIf="!isScheduleAutomation()"
          mat-icon-button
          (click)="editAutomation()"
          matTooltip="Edit"
        >
          <mat-icon>edit</mat-icon>
        </button>
        <button
          mat-icon-button
          (click)="deleteAutomation()"
          matTooltip="Delete"
          color="warn"
        >
          <mat-icon>delete</mat-icon>
        </button>
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="dialog-body">
    <mat-tab-group [(selectedIndex)]="selectedTab" [animationDuration]="0">
      <mat-tab label="Overview">
        <div class="tab-content">
          <div class="overview-section">
            <h3>Details</h3>
            <div class="detail-row">
              <span class="detail-label">Status:</span>
              <span class="detail-value">
                <span
                  [class]="
                    automation.enabled ? 'status-enabled' : 'status-disabled'
                  "
                >
                  {{ automation.enabled ? "Enabled" : "Disabled" }}
                </span>
              </span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Trigger:</span>
              <span class="detail-value">{{ getTriggerDisplay() }}</span>
            </div>
            <div class="detail-row" *ngIf="isScheduleAutomation()">
              <span class="detail-label">Target:</span>
              <span class="detail-value">{{ getTargetDisplay() }}</span>
            </div>
            <div class="detail-row" *ngIf="isScheduleAutomation()">
              <span class="detail-label">Frequency:</span>
              <span class="detail-value">{{ getFrequencyDisplay() }}</span>
            </div>
            <div class="detail-row" *ngIf="automation.frequency?.lastExecuted">
              <span class="detail-label">Last Executed:</span>
              <span class="detail-value">
                {{ automation.frequency?.lastExecuted | date: "medium" }}
              </span>
            </div>
            <div
              class="detail-row"
              *ngIf="
                automation.frequency?.nextExecution &&
                automation.frequency?.type !== 'milestone' &&
                isScheduleAutomation()
              "
            >
              <span class="detail-label">Next Execution:</span>
              <span class="detail-value">
                {{ automation.frequency?.nextExecution | date: "medium" }}
              </span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Total Executions:</span>
              <span class="detail-value">{{
                automation.executionCount || 0
              }}</span>
            </div>
          </div>

          <div class="overview-section">
            <h3>Action</h3>
            <div class="detail-row" *ngIf="automation.action.message">
              <span class="detail-label">Message:</span>
              <span class="detail-value">{{ automation.action.message }}</span>
            </div>
            <div
              class="detail-row"
              *ngIf="
                automation.action.rewards?.length || automation.action.reward
              "
            >
              <span class="detail-label">Rewards:</span>
              <span class="detail-value">
                <span *ngIf="automation.action.rewards?.length">
                  {{ automation.action.rewards.length }} reward(s)
                </span>
                <span
                  *ngIf="
                    !automation.action.rewards?.length &&
                    automation.action.reward
                  "
                >
                  1 reward
                </span>
              </span>
            </div>
          </div>

          <div
            class="overview-section"
            *ngIf="
              automation.target?.type === 'filtered_customers' &&
              hasActiveFilters()
            "
          >
            <h3>Filters</h3>
            <div class="filters-list">
              <div
                *ngFor="let filter of getActiveFilters()"
                class="filter-item"
              >
                {{ filter }}
              </div>
            </div>
          </div>

          <div class="overview-section" *ngIf="!isScheduleAutomation()">
            <h3>Conditions</h3>
            <div class="filters-list">
              <div
                *ngFor="let condition of getConditionDisplay()"
                class="filter-item"
              >
                {{ condition }}
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Runs">
        <div class="tab-content">
          <div class="runs-header">
            <single-select
              label="Filter by Date"
              [formCtrl]="dateFilterControl"
              [options]="dateFilterOptions"
              property="label"
              valueProperty="value"
              (selectionChange)="onDateFilterChange()"
            ></single-select>
          </div>

          <div *ngIf="loading" class="loading-container">
            <mat-spinner diameter="40"></mat-spinner>
          </div>

          <div *ngIf="!loading && executions.length === 0" class="empty-state">
            <mat-icon class="empty-icon">history</mat-icon>
            <p>No execution history yet</p>
          </div>

          <div
            *ngIf="!loading && executions.length > 0"
            class="table-container"
          >
            <ngx-datatable
              class="material"
              [headerHeight]="45"
              [rows]="executions"
              [scrollbarV]="false"
              [scrollbarH]="true"
              [footerHeight]="0"
              [columnMode]="'force'"
              [rowHeight]="60"
              [externalPaging]="false"
              [count]="executions.length"
            >
              <ngx-datatable-column
                name="Executed At"
                [resizeable]="false"
                [width]="180"
              >
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.executedAt | date: "medium" }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column
                name="Recipients"
                [resizeable]="false"
                [width]="100"
              >
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.recipientCount }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column
                name="Status"
                [resizeable]="false"
                [width]="100"
              >
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <span [class]="'status-' + row.status">
                    {{ row.status }}
                  </span>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
